/**
 * Format well-known agreement slugs to human-readable strings.
 * @param slug - The slug of the PoliciesConfig item.
 */
export const presentAgreementTitle = (slug: string) => {
  switch (slug) {
    case 'terms-of-service':
      return 'Terms';
    case 'privacy':
      return 'Privacy Policy';
    default:
      return slug;
  }
};
